import { createPopper, popper } from '@popperjs/core';

export function initDropMenuNavigation( menuSelector, subnavSelector) {

    let elementList = document.querySelectorAll(menuSelector);

    elementList.forEach(element => {
        let children = element.querySelector(subnavSelector);

        const popperInstance = createPopper(element, children, {
                
        });

        function show() {
            children.setAttribute('data-show', '');

            // We need to tell Popper to update the tooltip position
            // after we show the tooltip, otherwise it will be incorrect
            popperInstance.update();
        }

        function hide() {
            children.removeAttribute('data-show');
        }

        const showEvents = ['mouseenter', 'focus'];
        const hideEvents = ['mouseleave', 'blur'];

        showEvents.forEach((event) => {
            element.addEventListener(event, show);
        });

        hideEvents.forEach((event) => {
            element.addEventListener(event, hide);
        });

    });
}
